import { Medal } from "lucide-react";

// Icona che rappresenta il livello di reputazione (Stamina) col colore idoneo al livello.
export function StaminaBadge({ level, color, size = 16, showLabel = true, count }) {
  if (!level) return null;
  const c = color || "#a1a1aa";
  return (
    <span
      className="inline-flex items-center gap-1.5"
      title={`Reputazione: ${level}`}
      data-testid={`stamina-badge-${level}`}
    >
      <Medal width={size} height={size} strokeWidth={2.4} className="shrink-0" style={{ color: c }} />
      {showLabel && <span className="text-[11px] font-bold" style={{ color: c }}>{level}</span>}
      {count != null && <span className="text-[11px] font-bold tabular-nums" style={{ color: c }}>{count}</span>}
    </span>
  );
}
